const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Maintenance = () => import(/* webpackChunkName: "maintenance" */ './maintenance.vue');

export const ROUTE_NAME_MAINTENANCE = 'Maintenance' as const;

export default [
    {
        path: '/system/maintenance',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_MAINTENANCE,
                component: Maintenance,
                meta: { requiresAuth: true }
            }
        ]
    }
];
